import { FORMAT_TO_DISPLAY, type MetricCatalogEntry, type MetricFormat } from "./metricCatalog.js";

const ENGAGEMENT_COUNT_KPIS = new Set(["Likes", "Comments", "Post Engagements", "Like Count", "Comment Count"]);

export function fatigueKpiFormat(kpiName: string, catalog: MetricCatalogEntry[] = []): MetricFormat {
  if (ENGAGEMENT_COUNT_KPIS.has(kpiName)) return "number";
  const entry = catalog.find((metric) => metric.id === kpiName || metric.label === kpiName);
  if (entry) return entry.format;
  if (kpiName.endsWith("%")) return "percent";
  return "number";
}

export function fatigueKpiDisplayFormat(
  kpiName: string,
  catalog: MetricCatalogEntry[] = [],
): "currency" | "count" | "percent" | "ratio" {
  return FORMAT_TO_DISPLAY[fatigueKpiFormat(kpiName, catalog)];
}
